import axios from 'axios'
import { ClientOngoingLoad } from '@numeo/types-core'
import { ClientRateconRevision, RateconRevisionOverrides } from '@numeo/types-main-web-app'

export interface AcceptedRateconRevision {
    load: ClientOngoingLoad
    /** Set when the revision was accepted but some of its appointments could not be placed on the load,
     *  because the load's stops changed after it was raised. Not a failure: show it, do not block on it. */
    warning?: string
}

export const rateconRevisionsApi = {
    /** The pending revisions the banner shows (the newest 100), or only `loadId`'s pending revision when named. */
    async list(loadId?: string): Promise<{ items: ClientRateconRevision[]; count: number }> {
        const response = await axios.get('/updater/loads/rate-con-revisions', loadId ? { params: { loadId } } : undefined)
        return response.data.data
    },

    async get(id: string): Promise<ClientRateconRevision> {
        const response = await axios.get(`/updater/loads/rate-con-revisions/${id}`)
        return response.data.data
    },

    async accept(id: string, overrides?: RateconRevisionOverrides): Promise<AcceptedRateconRevision> {
        const response = await axios.post(`/updater/loads/rate-con-revisions/${id}/accept`, overrides ? { overrides } : undefined)
        return { load: response.data.data, warning: response.data.message }
    },

    async reject(id: string): Promise<void> {
        await axios.post(`/updater/loads/rate-con-revisions/${id}/reject`)
    },
}
